/*
  ColorPalette.js
  Betterment Labs 
  Created by Charles Major on 02/01/18. 
  Copyright © 2018 Betterment Labs, LLC. All rights reserved.

  Use :
*/
// https://coolors.co/f8d269-f9fbff-2b2f40-5a2154-7793f3
const ColorPalette = {
    Black: '#000000', // not used
    Yellow: '#F8D269', // not used
    BrighterYellow: '#FFD645',
    Red: '#B21E27', // not used
    Purple: '#5A2154', // not used
    DarkerPurpler: '#4D154F',
    Teal: '#00B1C5',
    Cream: '#FDF3D9', // not used
    SnowWhite: '#F9FBFF', // not used
    LightGray: '#C6C8C7', // not used
    DarkGray: '#434246', // not used
    MidBlue: '#332D8C', // not used
    LightBlue: '#7793F3',
    DarkBlue: "#2B2F40",
    White: '#FFFFFF',
}

export default ColorPalette;


// WEBPACK FOOTER //
// ./src/interface/AppStyles/ColorPalette.js